import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {endOfDay, startOfDay} from 'date-fns';
import moment from 'moment';

export const setFilters = createAsyncThunk(
  'staffHistoryFilters/setFilters',
  async (args: any) => {
    return args;
  },
);

const staffHistoryFilters = createSlice({
  name: 'staffHistoryFilters',
  initialState: {
    selectedFilters: {
      startDate: startOfDay(moment().subtract(1, 'months').toDate()).getTime(),
      endDate: endOfDay(new Date()).getTime(),
      patients: [],
      locations: [],
      types: [],
      status: ['completed', 'missing-values'],
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setFilters.fulfilled, (state, {payload}) => {
      Object.assign(state, {selectedFilters: payload});
    });
  },
});

export default staffHistoryFilters.reducer;
